import { render, staticRenderFns } from "./IfinancingPackages.vue?vue&type=template&id=a2b86152&"
import script from "./IfinancingPackages.vue?vue&type=script&lang=js&"
export * from "./IfinancingPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports